import { useEffect, useState } from 'react';
import Sidebar from '../../components/AdminDashboard/Sidebar';
import MetaData from '../../layouts/MetaData';
import TopBar from '../../components/AdminDashboard/TopBar';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import PatientCoreFields, { patientCoreSchema, patientCoreInitial, diagnosisRuleError, toPatientPayload } from '../../components/PatientForm/PatientCoreFields';
import TextField from '../../components/Form/TextField';
import GenderSelectbox from '../../components/Form/GenderSelectbox';
import { addPatient, getDoctors, getHrLists } from '../../actions/adminActions';
import { useDispatch, useSelector } from 'react-redux'
import { useAlert } from 'react-alert';
import { Link, useHistory } from 'react-router-dom';
import Select from 'react-select';
import OrganizationSelect from '../../components/Form/OrganizationSelect';
import ConsentRoleSelectBox from '../../components/Form/ConsentRoleSelectBox';
import { Alert } from 'react-bootstrap';
import {HIDE_ALERT_MESSAGE} from '../../constants/Common';
import { formatClinicianName } from '../../utils/clinicianName';



const AddPatient = (props) => {

    const dispatch = useDispatch();
    const alert = useAlert();
    const history = useHistory();

    const { message, error } = useSelector(state => state.common);
    const { doctors } = useSelector(state => state.doctor);
    const { hrs } = useSelector(state => state.hrslist);
    const [doctorId, setDoctorId] = useState('')
    const [hrId, setHrId] = useState('');
    const [orgId, setOrgId] = useState('');

    useEffect(() => {
        if (error) {
            alert.error(error);

            dispatch({
                type: HIDE_ALERT_MESSAGE
            })
        }

        dispatch(getDoctors());
        dispatch(getHrLists())

        if (message) {
            alert.success(message);
            props?.history.push('/patients');

            dispatch({
                type: HIDE_ALERT_MESSAGE
            })
        }

    }, [dispatch, error, message]);

    const validate = Yup.object().shape({
        emrId: Yup.string().required("EHR-ID is required"),
        firstname: Yup.string()
            .required('First Name is required')
            .min(2, 'Should be atleast 2 characters')
            .max(20, 'Should be less than 20 characters'),
        lastname: Yup.string()
            .min(2, 'Should be atleast 2 characters')
            .max(20, 'Should be less than 20 characters')
            .required('Last Name is Required'),
        email: Yup.string(),
        DOB: Yup.string().required('DOB is required'),
        phone1: Yup.string(),
        gender: Yup.string().required('Gender is required'),
        zipCode: Yup.string().min(2, 'should be atleast two characters').max(10, 'should not br more than ten characters'),
        address: Yup.string(),
        city: Yup.string(),
        state: Yup.string(),
        line2: Yup.string(),
        ssn: Yup.string(),
        insurancecompany: Yup.string(),
        ...patientCoreSchema,
    });

    const submitHandler = (values) => {
        if(!orgId){ alert.error('Organization is required'); return }
        values = {...values, organizationId: orgId}
        if(doctorId !== '')
        values = {...values,assigned_doctor_id:doctorId}

        if(hrId !== '')
        values = {...values,assigned_hr_id:hrId}
        const dxError = diagnosisRuleError(values);
        if (dxError) { alert.error(dxError); return }

        dispatch(addPatient(toPatientPayload(values)));
    }

    const assignDr =(dr) =>{
        setDoctorId(dr.value)
    }

    const assignHr =(hr) =>{
        setHrId(hr.value)
    }

    const optionsForDoc = []
    doctors && doctors.map((doc, index) => (
        optionsForDoc.push({ value: doc?._id, label: formatClinicianName(doc) })
    ))

    const optionsForHr = []
    hrs && hrs.map((hr, index) => (
        optionsForHr.push({ value: hr?._id, label: [hr?.firstname, hr?.lastname].join(" ") })
    ))

    return <>
        <MetaData title="Add New Patient" />
        <Sidebar />

        <section className="home-section">
            {/* TopBar */}
            <TopBar />

            <div className="shadow-lg p-3 mb-5 mr-4 ml-4 rounded" style={{ backgroundColor: '#FAFAFA' }}>
                <div className="home-content">
                    <div className="row-display">
                    <h5 style={{color: '#004aad'}}>
                        <i className="bx bx-user"></i> <strong>&nbsp;Add New Patient </strong>
                    </h5>
                        <div className="row-display">
                            
                                <button className="btn btn-secondary btn-sm" onClick={() => history.goBack()}>
                                    <i className='bx bx-arrow-back'></i>
                                </button>
                            &nbsp;&nbsp;
                            <Link to="/adminDashboard">
                                <button className="btn btn-secondary btn-sm">
                                    <i className='bx bxs-home'></i>
                                </button>
                            </Link>
                        </div>
                    </div>
                    <hr />

                    <Alert key="2" variant="warning">
                        1) Fields with <span style={{color: 'red'}}>* </span> are compulsory to add.
                    </Alert>

                    <Alert key="2" variant="danger">
                        2) EHR-ID must be unique. Patient would not be added if Same EHR-ID found.
                    </Alert>

                    <Alert key="2" variant="info">
                        3) Pick diagnoses from the ICD-10-CM list (CCM ≥ 2, PCM exactly 1, RPM ≥ 1).
                    </Alert>

                    <Formik initialValues={{
                             ...patientCoreInitial,
                        emrId:'',
                        firstname: '',
                        lastname: '',
                        DOB: '',
                        gender: '',
                        diseases: ''
                    }}
                        validationSchema={validate}
                        onSubmit={values => {
                            submitHandler(values)
                        }}
                    >
                            <div>
                                <Form>
                                    <div className="row">
                                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                        <TextField 
                                            label="EHR - ID" 
                                            name="emrId"  
                                            placeholder="EHR - ID"
                                            compulsory={true}
                                        />
                                    </div>

                                        {/* First Name */}
                                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                            <TextField
                                                label="First Name"
                                                name="firstname"
                                                type="text"
                                                placeholder="First Name"
                                                compulsory={true}
                                            />
                                        </div>

                                        {/* Last Name */}
                                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                            <TextField
                                                label="Last Name"
                                                name="lastname"
                                                type="text"
                                                placeholder="Last Name"
                                                compulsory={true}
                                            />
                                        </div>

                                        {/* Email */}
                                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                            <TextField
                                                label="Email"
                                                name="email"
                                                type="text"
                                                placeholder="Email"
                                            />
                                        </div>

                                        {/* DOB */}
                                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                            <TextField
                                                label="DOB"
                                                name="DOB"
                                                type="date"
                                                compulsory={true}
                                            />
                                        </div>

                                        {/* Gender */}
                                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                            <GenderSelectbox
                                                label="Gender"
                                                name="gender"
                                                compulsory={true}
                                            />
                                        </div>

                                        <PatientCoreFields orgId={orgId} providerId={doctorId} onProviderChange={setDoctorId} />
                                        {/* Insurance Company */}

                                        {/* Organization (Session 3b) */}
                                        <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                            <OrganizationSelect value={orgId} onChange={setOrgId} practiceOnly />
                                        </div>

                                        {/* Insurance Company */}
                                        <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                            <label className="form-label mt-3">Select Nurse</label>
                                             <Select
                                                options={optionsForHr}
                                                onChange={assignHr}
                                            />
                                        </div>

                                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                            <ConsentRoleSelectBox
                                                label="Consent Role"
                                                name="patientType"
                                            />
                                        </div>


                                    </div>{/* row ends here */}

                                    {/* Buttons */}
                                    <br />
                                    <div className="row mr-3" style={{ float: 'right' }}>
                                        <button className="edit-pill" style={{backgroundColor: 'red', color: 'white'}} type="reset">Reset</button> &nbsp;&nbsp;
                                        <button className="edit-pill" type="submit">Add Patient</button>
                                    </div>

                                    <br /><br /><br />
                                </Form>
                            </div>
                    </Formik>
                </div>
            </div>

        </section>
    </>;
};

export default AddPatient;
